import {Async, Empty, Loading} from 'Core/models/Async';
import {createAction} from 'Shared/utilities/actionCreator';
import {HistoryEvents} from 'ApplicationEntry/models/PolicyHistoryItems';

export enum PolicyHistoryActionType {
  CHANGE_POLICY_HISTORY = 'workQueue/CHANGE_POLICY_HISTORY',
  GET_POLICY_HISTORY = 'workQueue/GET_POLICY_HISTORY',
}

export const getPolicyHistory = () => createAction(PolicyHistoryActionType.GET_POLICY_HISTORY);
export const loadPolicyHistory = (policyHistoryItems: Async<HistoryEvents[]>) =>
  createAction(PolicyHistoryActionType.CHANGE_POLICY_HISTORY, {policyHistoryItems});

type PolicyHistoryState = Async<HistoryEvents[]>;

const DEFAULT_STATE = new Empty();

type PolicyHistoryAction = ReturnType<typeof loadPolicyHistory> | ReturnType<typeof getPolicyHistory>;

export default (state: PolicyHistoryState = DEFAULT_STATE, action: PolicyHistoryAction): PolicyHistoryState => {
  switch (action.type) {
    case PolicyHistoryActionType.GET_POLICY_HISTORY:
      return new Loading();
    case PolicyHistoryActionType.CHANGE_POLICY_HISTORY:
      return action.payload.policyHistoryItems;
    default:
      return state;
  }
};
